import * as $ from 'jquery';

// Use this on a page a user sits on for a long time to ensure that we don't lose the
// session or authentication
export class KeepAlive {
    handle: number; // set interval handle

    constructor() {
        this.handle = 0;
    }

    start() {
        const self = this;
        this.stop();
        this.handle = window.setInterval(() => self.ping(), 30000);
    }

    stop() {
        if (this.handle) {
            window.clearInterval(this.handle);
            this.handle = 0;
        }
    }

    ping() {
        $.post("/member/KeepAlive.ashx", function (data) {
            //console.log("Keep Alive: " + data);
        });
    }
}

